import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import * as serviceWorker from '../public/serviceWorker';
import Auth0ProviderWithHistory from "./auth0-provider-with-history";
import {BrowserRouter as Router} from "react-router-dom";
import {WebSocketLink} from "@apollo/client/link/ws";
import {useAuth0} from "@auth0/auth0-react";
import {ApolloClient, ApolloProvider, HttpLink, InMemoryCache, ApolloLink} from "@apollo/client";
import {split} from 'apollo-link';
import {getMainDefinition} from 'apollo-utilities';
import {setContext} from '@apollo/client/link/context';


const AppWithApollo = () => {

    const {getIdTokenClaims, isAuthenticated} = useAuth0();

    const wsLink = new WebSocketLink({
        uri: 'https://db.sancorsegurosafinidad.com.ar/v1/graphql',
        options: {
            lazy: true,
            reconnect: true,
            connectionParams: async () => {
                let token = null;
                // let role = 'user';

                return {
                    headers: {
                        Authorization: token ? `Bearer ${token}` : ""
                    },
                }

            },
        },
    });

    const withToken = setContext(() =>
        getIdTokenClaims().then(claims => {
            const token = claims.__raw;
            return {token}
        })
    );

    const authLink = new ApolloLink((operation, forward) => {
        const {token} = operation.getContext();
        operation.setContext(({headers}) => ({
            headers: {
                ...headers,
                Authorization: isAuthenticated ? `Bearer ${token}` : null,
            },
        }));
        return forward(operation)
    });

    const httpLink = new HttpLink({
        uri: 'https://db.sancorsegurosafinidad.com.ar/v1/graphql',
    });

    const link = split(
        // split based on operation type
        ({query}) => {
            const {kind, operation} = getMainDefinition(query);
            return kind === 'OperationDefinition' && operation === 'subscription';
        },
        wsLink,
        ApolloLink.from([withToken, authLink, httpLink]),
    );

    const client = new ApolloClient({
        link,
        cache: new InMemoryCache(),
    });

    return (
        <ApolloProvider client={client}>

                    <App/>

        </ApolloProvider>
    )
};

ReactDOM.render(
    <Router>
        <Auth0ProviderWithHistory>
            <AppWithApollo/>
        </Auth0ProviderWithHistory>
    </Router>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.register();
